<template>
  <div>
    <!-- Navbar -->
    <nav
      class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top d-lg-block "
    >
      <div class="container-fluid nav-cont-wrap">
        <!--<div class="navbar-wrapper">
                    <div class="navbar-minimize">
                        <button id="openSidebar" onclick="openNav()" class="btn btn-just-icon btn-white btn-fab btn-round">
                            <i class="fa fa-bars"></i>
                        </button>
                        <button id="closeSidebar" style="display: none;" onclick="closeNav()" class="btn btn-just-icon btn-white btn-fab btn-round">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>-->

        <div class="navbar-brand">
          <a href="/home"
            ><img src="/assets/logo/logo_blue.svg" class="logo"
          /></a>
        </div>
        <sidebar></sidebar>

        <div class="collapse navbar-collapse justify-content-end">
          <ul class="navbar-nav">
            <li class="nav-item navrightb mt-1 position-relative" v-if="help">
              <router-link
                class="nav-link"
                to="#"
                data-toggle="modal"
                data-target="#helpPageModal"
              >
                <i class="fas fa-question"></i>
              </router-link>
            </li>

            <li
              class="nav-item navrightb mt-1 ml-2 position-relative"
              v-if="user && messagebox == 1"
            >
              <router-link
                class="nav-link"
                v-bind:to="'/profile/' + user.id + '/messages'"
              >
                <span
                  v-if="countMessages > 0"
                  class="position-absolute notification badge badge-pill badge-danger"
                  >{{ countMessages }}</span
                >
                <i class="fas fa-inbox fa-1x text-dark"></i>
              </router-link>
            </li>

            <li class="nav-item navrightb mt-1 ml-2 position-relative">
              <router-link class="nav-link" to="/community/email">
                <i class="fas fa-envelope fa-lg text-dark"></i>
              </router-link>
            </li>
            <!-- <li class="nav-item navrightb mt-1 ml-2">
                            <a class="nav-link" href="" >
                                <img src="./../../../assets/images/Fill.svg" alt="" style="height: 15px">
                            </a>
                        </li> -->
            <!-- <li class="nav-item navrightb mt-1 ml-2" >
                            <a class="nav-link" href="" >
                                <img src="./../../../assets/images/Settings.svg" alt="" style="height: 15px">
                            </a>
                        </li> -->

            <li class="nav-item navrightb ml-2" v-if="user">
              <!--<router-link  class="nav-link" v-bind:to="'/profile/'+user.id+'/view'" v-if="user.profile_image !==null">
                                <img v-bind:src="user.profile_image"  style="height: 35px;width: 35px;border: 4px solid #4192D9;border-radius: 50%" alt="">
                            </router-link>
                            <router-link class="nav-link" v-bind:to="'/profile/'+user.id+'/view'" v-else>
                                <img src="/assets/icon.jpg" style="height: 35px;width: 35px;border: 4px solid #4192D9;border-radius: 50%" alt="">

                            </router-link>-->
              <div class="dropdown nav-link pb-0">
                <button
                  class="btn dropdown-btn dropdown-toggle pt-0 pb-0"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="user.profile_image !== null"
                >
                  <img
                    v-bind:src="user.profile_image"
                    style="height: 35px;width: 35px;border: 4px solid #4192D9;border-radius: 50%"
                    alt=""
                  />
                </button>
                <button
                  class="btn dropdown-btn dropdown-toggle pt-0 pb-0 "
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-else
                >
                  <img
                    src="/assets/icon.jpg"
                    style="height: 35px;width: 35px;border: 4px solid #4192D9;border-radius: 50%"
                    alt=""
                  />
                </button>

                <div
                  style="left: unset;right: 0;"
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <router-link
                    v-if="user"
                    v-bind:to="'/profile/' + user.id + '/view'"
                    class="dropdown-item"
                    href="#"
                  >
                    Profiel
                  </router-link>
                  <router-link
                    v-if="user"
                    v-bind:to="'/profile/' + user.id + '/password'"
                    class="dropdown-item"
                    href="#"
                  >
                    Wachtwoord
                  </router-link>
                  <a @click="logout()" class="dropdown-item" href="#"
                    >Uitloggen</a
                  >
                </div>
              </div>
            </li>

            <!-- <li class="nav-item navrightb ml-2">
                            <div class="nav-link">
                            <input class="search-box" type="text" placeholder="Zoeken"><button class="search-btn"><img
                                    src="./../../../assets/images/search.svg" alt="Search" style="margin-bottom: 4px"></button>
                            </div>
                        </li> -->
          </ul>
        </div>
      </div>
    </nav>
    <foot></foot>
    <helpModal v-if="help" :help="help" />
  </div>
</template>

<script>
import sidebar from "./sidebar";
import footer from "./footer";
import helpModal from "./helpModal";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "navbar",
  components: { sidebar, foot: footer, helpModal },
  watch: {
    $route(to) {
      this.getHelpPages(to.name, to.path);
    },
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
  },
  data() {
    return {
      messagebox: process.env.VUE_APP_MESSAGEBOX,
      countMessages: 0,
      help: null,
    };
  },
  methods: {
    ...mapActions({
      logoutAction: "auth/signOut",
    }),

    async logout() {
      await this.logoutAction();

      this.$router.replace({ name: "login" });
    },
    getHelpPages(routeName = this.$route.name, routePath = this.$route.path) {
      this.$store
        .dispatch(
          "get",
          `/api/v1/help-pages/search-path?routeName=${routeName}&path=${routePath}`
        )
        .then((response) => {
          this.help = response.data.data;
          this.help.content = JSON.parse(this.help.content);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
  },
  mounted() {
    this.$store
      .dispatch("get", "/api/v1/message/1/count_unread")
      .then((response) => {
        this.countMessages = response.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });
    this.getHelpPages();
  },
};
</script>

<style scoped>
.nav-link:hover {
  color: black;
}
.navbar {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 10px #00000029;
}

.logo {
  width: 200px;
}

.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #c4c7d5;
  border-radius: 4px;
  height: 35px;
  width: 200px;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -30px;

  -webkit-appearance: none;
}

.dropdown-toggle::after {
  content: unset !important;
}
@media screen and (max-width: 400px) {
  .logo {
    width: 183px;
  }
}
.notification {
  top: 0;
  right: 0;
}
.navrightb .helpbtn {
  width: 21px;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 21px;
  top: 0;
  border: none;
  background-color: transparent;
  outline: none;
  box-shadow: none;
}
</style>
